export default "__VITE_ASSET__N86kDcxb__"